import React, { useEffect, useState } from 'react';
import { IonContent, IonPage, IonButton } from '@ionic/react';
import './ThankYou.scss';
import { AppointmentStepProps } from '../../navigators/AppointmentNavigator';
import AppHeader from '../../components/AppHeader';
import { Appointment, Laboratory } from '../../models';
import { AppointmentsRootState } from '../../store/reducers/appointments';
import { resetAppointment } from '../../store/actions/appointments';
import { connect } from 'react-redux';
import { useRouteMatch } from 'react-router';
import {
  APPOINTMENT_CHECKIN,
  APPOINTMENT_CHECKIN_COVID
} from '../../navigators/AppStackNavigator';
import AppRating from '../../components/AppRating';
import { unilabsHome } from '../../const';

const mapStateToProps = (
  state: { appointments: AppointmentsRootState },
  ownProps: any
) => {
  return {
    appointment: new Appointment(state.appointments.appointment)
  };
};

const mapDispatchToProps = (dispatch: Function, ownProps: any) => ({
  resetAppointment: () => dispatch(resetAppointment())
});

const ThankYou: React.FC<
  AppointmentStepProps & {
    bodyText?: string;
    showRatingForm?: boolean;
    lastSelectedLaboratory: Laboratory | null;
  } & ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>
> = ({
  appointment,
  bodyText = 'Un e-mail de confirmation vous a été envoyé. Vous recevrez également un rappel 24h avant votre créneau de prise en charge.',
  resetAppointment,
  showRatingForm = true,
  lastSelectedLaboratory = null
}) => {
  const match = useRouteMatch();

  let thankYou = bodyText;

  if (
    match.path.includes(APPOINTMENT_CHECKIN) ||
    match.path.includes(APPOINTMENT_CHECKIN_COVID)
  ) {
    thankYou = appointment.laboratory?.confirmation_message || bodyText;
  }

  const [thankYouMessage] = useState(thankYou);

  const [showRatingModal, setShowRatingModal] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      resetAppointment();
    });

    if (showRatingForm) {
      const ratingModalTimer = setTimeout(() => {
        setShowRatingModal(true);
      }, 1000);
      return () => clearTimeout(ratingModalTimer);
    }
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <IonPage>
      <AppHeader />
      <IonContent className="appointment-thank-you ion-padding ion-text-center">
        <div className="wrapper wrapper--centered">
          <h1>Merci !</h1>
          <p dangerouslySetInnerHTML={{ __html: thankYouMessage }}></p>
          <IonButton href={unilabsHome}>Revenir à la page d'accueil</IonButton>
        </div>
      </IonContent>
      {showRatingForm && lastSelectedLaboratory ? (
        <AppRating
          laboratory={lastSelectedLaboratory}
          isOpen={showRatingModal}
          onClose={() => setShowRatingModal(false)}
        />
      ) : null}
    </IonPage>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ThankYou);
